export enum AuthClientErrors {
  GraphQLOperationalError = 'GraphQL Operational Error',
  InvalidCredentialsError = 'Invalid Messenger Credentials',
  UnauthorizedError = 'Authentication hook unauthorized this request',
  NoInternetError = 'The Internet connection appears to be offline.',
}
